function generateId(): string {
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

function getSessionId(): string {
  try {
    const key = "spcx_sid";
    const existing = sessionStorage.getItem(key);
    if (existing) return existing;
    const id = generateId();
    sessionStorage.setItem(key, id);
    return id;
  } catch {
    return generateId();
  }
}

export function createTelemetry(projectId: string, apiBase: string) {
  const sessionId = getSessionId();

  return function fireEvent(
    type: "open" | "close" | "search" | "result_click" | "ai_ask" | "feedback_open" | "feedback_submit",
    data: { query?: string; url?: string; text?: string } = {}
  ): void {
    fetch(`${apiBase}/api/projects/${projectId}/events`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, sessionId, ...data }),
    }).catch(() => {});
  };
}
